import React from 'react';

const MercadoPagoOpcion = () => (
  <div className='panel panel-default custom bordeado '>
    <div className='panel-body'>
      <div className='cuotas mp'>
        <div className='row'>
          <div className='col-lg-2 col-md-2 col-sm-2 col-xs-4' style={{ marginLeft: '2%' }}>
            <img src={`${process.env.RAZZLE_URL}/assets/img/pagos/mercadopago.png`} className='img-cuotas mp' alt='Mercado pago' />
          </div>
          <div className='col-lg-5 col-md-6 col-sm-6 col-xs-8' style={{ width: 'auto' }}>
            <div className='promo-text' style={{ marginTop: '1%' }}>
              <span>Paga hasta en 12 cuotas con bancos seleccionados</span>
            </div>
          </div>
          <div className='col-lg-5 col-md-4 col-sm-4 col-xs-12 text-center'>
            <a className='btn-mp-promociones pull-left' href='https://www.mercadopago.com.ar/cuotas' target='_blank' rel='noopener noreferrer'>VER PROMOCIONES BANCARIAS</a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MercadoPagoOpcion;
